export default "__VITE_ASSET__Dp6KFmkb__"